module.exports = __webpack_public_path__ + "static/media/server_3.658c6ecc.png";